import { getToApi, postToApi, putToApi, deleteToApi } from './axios';

const qs = (params) => {
  const sp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') sp.append(k, v);
  });
  const s = sp.toString();
  return s ? `?${s}` : '';
};

// getToApi resuelve el body directo; postToApi/putToApi resuelven la respuesta
// axios completa (body en .data).
export const listReportesVisita = (params) => getToApi(`/reportes-visita${qs(params)}`);
export const countsReportesVisita = (params) => getToApi(`/reportes-visita/counts${qs(params)}`);
export const getReporteVisita = (id) => getToApi(`/reportes-visita/${id}`);
export const createReporteVisita = (body) =>
  postToApi('/reportes-visita', body).then((r) => r.data);
export const updateReporteVisita = (id, body) =>
  putToApi(`/reportes-visita/${id}`, body).then((r) => r.data);
export const cerrarReporteVisita = (id, body) =>
  postToApi(`/reportes-visita/${id}/cerrar`, body || {}).then((r) => r.data);
export const deleteReporteVisita = (id) => deleteToApi(`/reportes-visita/${id}`);
